import {SampleType} from 'types/model/enumeration/SampleType';
import {SelectOptions} from 'forms/components/BasicSelect';

export const sampleTypeOptions: SelectOptions<SampleType> = [
    {value: 'RAW_COW_MILK', label: 'Syrové kravské mléko'},
    {value: 'RAW_GOAT_MILK', label: 'Syrové kozí mléko'},
    {value: 'RAW_SHEEP_MILK', label: 'Syrové ovčí mléko'},
    {value: 'SKIMMED_MILK', label: 'Odstředěné mléko'},
];
